import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/users";

class UserService {
  fetchUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Error occured while fetching user's info.");
    }
  };

  editUserInfo = async (formData) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/me`, formData);
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data.data;
      return { user };
    } catch (err) {
      throw handleError(err, "Error occured while editing user's info.");
    }
  };

  signUpStudent = async (formData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/sign-up/student`,
        formData
      );
      if (response.status !== 201) {
        throw new Error();
      }
      const { student } = response.data.data;
      return { student };
    } catch (err) {
      throw handleError(err, "Error occured while signing up new student.");
    }
  };

  fetchStudents = async (page, sortBy, order, search) => {
    try {
      if (!sortBy) {
        sortBy = "";
      }
      if (!order) {
        order = "ASC";
      }
      const response = await axiosApiClient.get(
        `${BASE_URL}/students?page=${page}&sortBy=${sortBy}&order=${order}&search=${search}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, total, perPage } = response.data;
      return { data, total, perPage };
    } catch (err) {
      throw handleError(err, "Error occured while fetching students.");
    }
  };

  editStudent = async (formData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/edit/student`,
        formData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { student } = response.data.data;
      return { student };
    } catch (err) {
      throw handleError(err, "Error occured while editing student.");
    }
  };

  signUpStaff = async (formData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/sign-up/staff`,
        formData
      );
      if (response.status !== 201) {
        throw new Error();
      }
      const { staff } = response.data.data;
      return { staff };
    } catch (err) {
      throw handleError(err, "Error occured while signing up new staff.");
    }
  };

  fetchStaff = async (page, sortBy, order, search) => {
    try {
      if (!sortBy) {
        sortBy = "";
      }
      if (!order) {
        order = "ASC";
      }
      const response = await axiosApiClient.get(
        `${BASE_URL}/staff?page=${page}&sortBy=${sortBy}&order=${order}&search=${search}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, total, perPage } = response.data;
      return { data, total, perPage };
    } catch (err) {
      throw handleError(err, "Error occured while fetching staff.");
    }
  };

  editStaff = async (formData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/edit/staff`,
        formData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { staff } = response.data.data;
      return { staff };
    } catch (err) {
      throw handleError(err, "Error occured while editing staff.");
    }
  };

  fetchTeachers = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/teachers`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, total } = response.data;
      return { data, total };
    } catch (err) {
      throw handleError(err, "Error occured while fetching teachers.");
    }
  };
}

export default new UserService();
